const url = window.location.hostname === `localhost`
            //? `http://localhost:7070`
            ? `https://projects.barcelonacodeschool.com/kim-commerce`
            : `https://projects.barcelonacodeschool.com/kim-commerce`;

export { url };
